import styled from 'styled-components';
import { Button } from '../../components/Button';
import { Wrapper as InputTextWrapper } from '../../components/InputText/wrapper';
import { size } from '../../layout/helpers';

export const InputWrapper = styled.div.withConfig({ componentId: 'sc-nm9j1b-0' })`
    display: flex;
    align-items: center;
    gap: ${size(2)};

    ${InputTextWrapper} {
        flex: 1 1 auto;
    }

    ${Button} {
        flex-shrink: 0;
    }

    ${(props) => props.theme.breakpoint.LtSm} {
        flex-direction: column;

        ${InputTextWrapper} {
            width: 100%;
        }

        ${Button} {
            width: 100%;
        }
    }
`;
